/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IReturnsInformationPageData } from './returns-information-page.data';
import { IReturnsInformationPageProps } from './returns-information-page.props.autogenerated';

export interface IReturnsInformationPageViewProps extends IReturnsInformationPageProps<IReturnsInformationPageData> {}

/**
 *
 * ReturnsInformationPage component
 * @extends {React.PureComponent<IReturnsInformationPageProps<IReturnsInformationPageData>>}
 */
class ReturnsInformationPage extends React.PureComponent<IReturnsInformationPageProps<IReturnsInformationPageData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default ReturnsInformationPage;
